module.exports = __webpack_public_path__ + "img/emoji_40.79fa19ca.png";